/**
 * Services Index
 * Exports all service modules
 */

// API Services
export { api, scrapperApi, logAnalyzerApi, createApiClient, switchLogAnalyzerEnvironment, ApiError as LegacyApiError } from './api';
export { 
  createApiService, 
  getSharedApiService, 
  setUnauthorizedCallback,
  ApiError 
} from './apiService';

// Auth Service
export { 
  createAuthService
} from './authService';

// Domain Services
export * from './siteService';
export * from './syntheticMonitorService';
export * from './scrapperService';
export * from './incidentService';
export * from './alertService';
export * from './logAnalyzerService';
export * from './notificationService';
export * from './userService';
export * from './organizationService';
export * from './salesAnalyticsService';
